export { default } from './CloseIcon';
